module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('VNavigator', {
    attrs: {
      "title": "设置与关于"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', [_c('router-link', {
    attrs: {
      "to": "/aboutUs"
    }
  }, [_c('div', {
    staticClass: "about1"
  }, [_vm._v("\n          关于我们\n          "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "jump"
  }, [_c('span', {
    staticClass: "arrow"
  })])])], 1), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jump"
  }, [_vm._v("\n        1.0\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.tuichu
      }),
      expression: "{methods:tuichu}"
    }],
    staticClass: "tuichu"
  }, [_vm._v("\n        退出\n      ")])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about2"
  }, [_vm._v("\n        版本\n        "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("\n      燕郊在线提供研发与技术服务\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28a9c290"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting.vue
// module id = 765
// module chunks = 1